import React, { useRef, useState } from 'react';
import { Spinner } from 'app/src/components/Spinner';
import { forTemplate } from 'app/common/lib/util/i18n';
import styles from './Upload.less';
import cx from 'classnames';
import { useUploadCoverMutation } from '@trello/graphql/generated';
import { track } from '@trello/analytics';

const format = forTemplate('card_cover_chooser');

interface UploadProps {
  onFileUploaded: () => void;
  cardId: string;
  onFileSelected: () => void;
  onUploadFailed: () => void;
}

export const Upload: React.FunctionComponent<UploadProps> = ({
  cardId,
  onFileSelected,
  onFileUploaded,
  onUploadFailed,
}) => {
  const [uploadCover, { loading, error }] = useUploadCoverMutation({
    onError: onUploadFailed,
    onCompleted: () => {
      track('Card Cover Chooser', 'Set cover to an upload');
      onFileUploaded();
    },
  });
  const [file, setFile] = useState<File | undefined>();
  const fileInput = useRef<HTMLInputElement>(null);

  if (loading) {
    return <Spinner centered />;
  }

  return (
    <div>
      <h4 className={styles.heading}>{format('upload')}</h4>
      <input
        ref={fileInput}
        className={styles.fileInput}
        type="file"
        accept="image/*"
        onClick={() => {
          setFile(undefined);
        }}
        onChange={async (e) => {
          const input = e.target;
          const selectedFile = input.files && input.files[0];
          if (selectedFile) {
            setFile(selectedFile);
            onFileSelected();
            uploadCover({
              variables: {
                cardId,
                file: selectedFile,
              },
            });
          }
        }}
      />

      <button
        className={cx('button', styles.upload)}
        onClick={() => {
          fileInput.current && fileInput.current.click();
          track('Card Cover Chooser', 'Clicked Upload');
        }}
      >
        {format('upload-a-cover-image')}
      </button>
      {error && file ? (
        <div className={styles.error}>
          {format('unable-to-use-file-as-card-cover', { fileName: file.name })}
        </div>
      ) : (
        <div className={styles.tip}>{format('tip-drag-an-image')}</div>
      )}
    </div>
  );
};
